module.exports = __webpack_public_path__ + "static/media/stru2.861116a5.jpg";